import { ErrMsgCodeMap } from '@/api/errMap';
export const getDomain = (systemApi) => {
    const user = systemApi.getCurrentUser();
    return user === null || user === void 0 ? void 0 : user.domain;
};
export const getCurrentAccount = (systemApi) => { var _a; return ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || ''; };
export const getEmail = (systemApi) => { var _a; return (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id; };
export const getCurrentContactId = (systemApi) => {
    var _a, _b;
    const user = systemApi.getCurrentUser();
    return ((_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact.id) || ((_b = user === null || user === void 0 ? void 0 : user.prop) === null || _b === void 0 ? void 0 : _b.contactId);
};
export const getCurrentCompanyId = (systemApi, email) => systemApi.getCurrentCompanyId(email);
export const useTime = (start) => Date.now() - start + 'ms';
export const doGetModelDisplayEmail = (model) => {
    var _a, _b, _c;
    try {
        if (model && 'id' in model) {
            return model.hitQueryEmail || model.displayEmail || model.accountName;
        }
        return ((_a = model.contact) === null || _a === void 0 ? void 0 : _a.hitQueryEmail) || ((_b = model.contact) === null || _b === void 0 ? void 0 : _b.displayEmail) || ((_c = model.contact) === null || _c === void 0 ? void 0 : _c.accountName);
    }
    catch (e) {
        console.error('[api_contact_util] doGetModelDisplayEmail error', e, model);
        return '';
    }
};
export const transContactModel2ContactItem = (item) => {
    var _a, _b, _c;
    try {
        const { id, type, avatar, contactName, position, accountType } = item.contact;
        const email = doGetModelDisplayEmail(item);
        const emailList = new Set([email]);
        if ((_a = item === null || item === void 0 ? void 0 : item.contactInfo) === null || _a === void 0 ? void 0 : _a.length) {
            item.contactInfo.forEach(info => {
                if (info.contactItemType === 'EMAIL' && info.contactItemVal) {
                    emailList.add(info.contactItemVal);
                }
            });
        }
        return {
            id,
            type,
            avatar,
            name: contactName,
            email,
            position,
            accountType,
            customerRole: (_b = item.customerOrgModel) === null || _b === void 0 ? void 0 : _b.role,
            createTime: (_c = item.customerOrgModel) === null || _c === void 0 ? void 0 : _c.createTime,
            emailList: [...emailList],
        };
    }
    catch (e) {
        const CommonNull = null;
        console.error('[api_contact_util] transContactModel2ContactItem error', e);
        return CommonNull;
    }
};
export const findContactInfoVal = (contactInfoList, type = 'EMAIL') => {
    var _a;
    if (!contactInfoList || !contactInfoList.length) {
        return '';
    }
    return ((_a = contactInfoList.find(item => item.contactItemType === type)) === null || _a === void 0 ? void 0 : _a.contactItemVal) || '';
};
export const contactLog = (key, loggerApi, data) => {
    const APPENDIX = 'contact';
    const resultData = data || {};
    loggerApi.track(key, Object.assign({ appendix: APPENDIX }, resultData));
};
export const logger = (key, loggerApi, data) => {
    console.warn(key, data);
    loggerApi.track(key, {
        appendix: 'contact',
        data,
    });
};
export const catchError = (reason) => {
    if (typeof reason === 'string') {
        return ErrMsgCodeMap[reason] || reason;
    }
    if (reason instanceof Error) {
        return reason.message;
    }
    return 'unknown error';
};
export const getPublicParamFromMultipleOptions = (options) => ({
    isMainAccount: options.isMainAccount,
    _account: options._account,
});
